import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM, toAttributeBoolean, toAttributeBooleanString } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapMultipleChoiceSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapmultiplechoice: {
      group: 'block',
      content: '(madcapquestion | madcapmultiplechoiceitem | madcapcorrectfeedback | madcapincorrectfeedback | madcapsubmitquestionbutton | madcapsnippetblock | mcCentralContainer | div | bullet_list | ordered_list | blockquote | fieldset | form)*',
      attrs: {
        'MadCap:isMultiResponse': {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        },
        'MadCap:questionID': { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:multipleChoice',
        getAttrs(dom: HTMLElement) {
          const attrs = getSchemaAttrs(dom, ['MadCap:questionID', 'MadCap:isMultiResponse']);

          return {
            ...attrs,
            'MadCap:isMultiResponse': toAttributeBoolean(attrs['MadCap:isMultiResponse'])
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:multipleChoice'
    },

    madcapquestion: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      defining: true,
      parseDOM: [{ tag: 'MadCap\\:question' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:question'
    },

    madcapmultiplechoiceitem: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      defining: true,
      attrs: {
        'MadCap:correctAnswer': {
          default: undefined,
          toFlareXML(value: any): string {
            return toAttributeBooleanString(value);
          }
        }
      },
      parseDOM: [{
        tag: 'MadCap\\:multipleChoiceItem',
        getAttrs(dom: HTMLElement) {
          const attrs = getSchemaAttrs(dom, ['MadCap:correctAnswer']);

          return {
            ...attrs,
            'MadCap:correctAnswer': toAttributeBoolean(attrs['MadCap:correctAnswer'])
          };
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:multipleChoiceItem'
    },

    madcapcorrectfeedback: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      isolating: true,
      defining: true,
      parseDOM: [{ tag: 'MadCap\\:correctFeedback' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:correctFeedback'
    },

    madcapincorrectfeedback: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      isolating: true,
      defining: true,
      parseDOM: [{ tag: 'MadCap\\:incorrectFeedback' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:incorrectFeedback'
    },

    madcapsubmitquestionbutton: {
      group: 'block',
      parseDOM: [{ tag: 'MadCap\\:submitQuestionButton' }],
      toDOM(node) {
        const outputSpec = nodeToDOM(node);
        outputSpec.dom.textContent = 'Submit';
        return outputSpec;
      },
      tagName: 'MadCap:submitQuestionButton',
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
